import { motion } from "framer-motion";
import { CHAPTERS, IMAGES } from "../../data";
import { Reveal, Kicker } from "./Reveal";

export default function Philosophy() {
  return (
    <section id="philosophy" data-testid="philosophy-section" className="relative py-24 lg:py-36 bg-sand">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-14 lg:gap-20">
          <div className="lg:col-span-5">
            <Reveal><Kicker>The Integral Manifesto</Kicker></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-serif text-4xl sm:text-5xl leading-[1.08] text-ink tracking-tight">
                Wealth as a <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-gold to-saffron">divine instrument</span> of evolution.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg text-stoneink leading-relaxed">
                We invest where consciousness meets capability. Every venture we back is a laboratory for a truer, more harmonious way of living — economically sound, ecologically whole, and spiritually awake.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-9 relative aspect-[5/4] rounded-3xl overflow-hidden border border-brass/40 shadow-[0_30px_70px_-35px_rgba(140,98,33,0.55)]">
                <img src={IMAGES.matrimandir} alt="The Matrimandir at Auroville" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            <div className="divide-y divide-borderln border-t border-borderln">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.number} delay={i * 0.08}>
                  <motion.div data-testid="philosophy-chapter-item" whileHover={{ x: 8 }} transition={{ type: "spring", stiffness: 300, damping: 24 }}
                    className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 py-8">
                    <span className="font-display text-3xl sm:text-4xl text-brass group-hover:text-gold transition-colors">{c.number}</span>
                    <div>
                      <h3 className="font-serif text-2xl sm:text-3xl text-ink">{c.title}</h3>
                      <p className="mt-2 text-stoneink leading-relaxed max-w-xl">{c.desc}</p>
                    </div>
                  </motion.div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
